import MissionControlMissionsProgress from "views/Account/MissionControl/MissionsProgress";

import DashboardOverviewColumnLearnDropdown from "./Dropdown";

const DashboardOverviewColumnLearn = () => (
  <MissionControlMissionsProgress headerSuffix={<DashboardOverviewColumnLearnDropdown />} />
);

export default DashboardOverviewColumnLearn;
